















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<GenericBulkAction>({})
export default class GenericBulkAction extends Vue {
  @Prop({ default: '' })
  protected icon!: string;

  @Prop({ default: '' })
  protected tooltip!: string;
}
